module.exports = __webpack_public_path__ + "img/blockchain_5.8d17b848.png";